import { styled, YStack } from 'tamagui'

const Page = styled(YStack, {
  flexGrow: 1,
  height: '100%',
  width: '100%',
})

export default Page
